import { computed, input, signal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CrudManagerService } from '@common/crud-ui/frontend-shared';
import { AppMessagesComponent } from '@common/messages/frontend-shared';
import { UiButtonComponent } from '@common/ui/frontend-shared/button';
import { DynamicDialogRef } from '@common/ui/frontend-shared/dynamic-dialog';
import { UiMessageComponent } from '@common/ui/frontend-shared/message';
import { UiSpinnerComponent } from '@common/ui/frontend-shared/spinner';
import { UiToolbarComponent } from '@common/ui/frontend-shared/toolbar';
import { ManagerConvertUserRequest, UserConversion, UserConversionHelper, UserItem } from '@common/users/shared';
import { AppRequestService, LocalMessageHandlerService, NgLetDirective } from '@core/frontend-shared';
import * as i0 from "@angular/core";
import * as i1 from "@core/frontend-shared";
import * as i2 from "@common/crud-ui/frontend-shared";
import * as i3 from "@common/ui/frontend-shared/dynamic-dialog";
import * as i4 from "@angular/forms";
import * as i5 from "@common/ui/frontend-shared/input-dropdown";
function UserConvertComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0)(1, "table", 2)(2, "tbody")(3, "tr")(4, "td");
    i0.ɵɵtext(5, "Gew\u00E4hlter Account");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "td");
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "tr")(9, "td");
    i0.ɵɵtext(10, "Account-Inhaber");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "td");
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(13, "tr")(14, "td");
    i0.ɵɵtext(15, "Aktuelle Rolle");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "td");
    i0.ɵɵtext(17, "Teammitglied");
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(ctx_r0.user().username);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate2("", ctx_r0.user().firstName, " ", ctx_r0.user().lastName);
  }
}
function UserConvertComponent_Conditional_1_ng_template_0_Conditional_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵelement(1, "app-messages");
    i0.ɵɵelementStart(2, "ui-input-dropdown", 3);
    i0.ɵɵlistener("ngModelChange", function UserConvertComponent_Conditional_1_ng_template_0_Conditional_2_Conditional_0_Template_ui_input_dropdown_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r0.selectedConversion.set($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p");
    i0.ɵɵtext(4, "Duch die Konvertierung...");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "ul")(6, "li");
    i0.ɵɵtext(7, "Erh\u00E4lt der Account Management-Zugriff");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "li");
    i0.ɵɵtext(9, "Kann die Person ihre Pflichtkurse selbst festlegen");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "li");
    i0.ɵɵtext(11, "Erscheint in der Manager-Liste im Profil unter \"Mein Unternehmen\"");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "li");
    i0.ɵɵtext(13, "Kann nicht mehr von Ihnen eingesehen/bearbeitet werden (Selbstverwaltung)");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(14, "ui-toolbar");
    i0.ɵɵelement(15, "div");
    i0.ɵɵelementStart(16, "button", 4);
    i0.ɵɵlistener("click", function UserConvertComponent_Conditional_1_ng_template_0_Conditional_2_Conditional_0_Template_button_click_16_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r0.execute());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const conversionOpts_r3 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("options", conversionOpts_r3)("ngModel", ctx_r0.selectedConversion());
    i0.ɵɵadvance(14);
    i0.ɵɵproperty("disabled", !ctx_r0.selectedConversion());
  }
}
function UserConvertComponent_Conditional_1_ng_template_0_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0)(1, "p");
    i0.ɵɵtext(2, "F\u00FCr diesen Account wurden keine Konvertierungsm\u00F6glichkeiten gefunden.");
    i0.ɵɵelementEnd()();
  }
}
function UserConvertComponent_Conditional_1_ng_template_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, UserConvertComponent_Conditional_1_ng_template_0_Conditional_2_Conditional_0_Template, 17, 3)(1, UserConvertComponent_Conditional_1_ng_template_0_Conditional_2_Conditional_1_Template, 3, 0, "div", 0);
  }
  if (rf & 2) {
    const conversionOpts_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵconditional(conversionOpts_r3.length ? 0 : 1);
  }
}
function UserConvertComponent_Conditional_1_ng_template_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 0)(1, "ui-message", 5);
    i0.ɵɵtext(2, "Die Konvertierung wurde erfolgreich durchgef\u00FChrt.");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(3, "ui-toolbar");
    i0.ɵɵelement(4, "div");
    i0.ɵɵelementStart(5, "button", 6);
    i0.ɵɵlistener("click", function UserConvertComponent_Conditional_1_ng_template_0_Conditional_3_Template_button_click_5_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.closeDialog());
    });
    i0.ɵɵelementEnd()();
  }
}
function UserConvertComponent_Conditional_1_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵelement(1, "app-messages");
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(2, UserConvertComponent_Conditional_1_ng_template_0_Conditional_2_Template, 2, 1);
    i0.ɵɵconditionalCreate(3, UserConvertComponent_Conditional_1_ng_template_0_Conditional_3_Template, 6, 0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!ctx_r0.executing() && !ctx_r0.success() ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r0.executing() && ctx_r0.success() ? 3 : -1);
  }
}
function UserConvertComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UserConvertComponent_Conditional_1_ng_template_0_Template, 4, 2, "ng-template", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngLet", ctx_r0.conversionOptions());
  }
}
function UserConvertComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-spinner");
  }
}
export let UserConvertComponent = /*#__PURE__*/(() => {
  class UserConvertComponent {
    constructor(requestService, crudManager, messages, ref) {
      this.requestService = requestService;
      this.crudManager = crudManager;
      this.messages = messages;
      this.ref = ref;
      this.user = input(null, ...(ngDevMode ? [{
        debugName: "user"
      }] : /* istanbul ignore next */[]));
      this.possibleConversions = computed(() => {
        return [UserConversion.ToCompanyManager];
      }, ...(ngDevMode ? [{
        debugName: "possibleConversions"
      }] : /* istanbul ignore next */[]));
      this.conversionOptions = computed(() => {
        const possibleConversions = this.possibleConversions();
        return possibleConversions.map(conversionType => {
          return {
            value: conversionType,
            label: UserConversionHelper.getLabel(conversionType)
          };
        });
      }, ...(ngDevMode ? [{
        debugName: "conversionOptions"
      }] : /* istanbul ignore next */[]));
      this.initialized = computed(() => {
        const user = this.user();
        return user && user.userRole;
      }, ...(ngDevMode ? [{
        debugName: "initialized"
      }] : /* istanbul ignore next */[]));
      this.selectedConversion = computed(() => this.possibleConversions()[0], ...(ngDevMode ? [{
        debugName: "selectedConversion"
      }] : /* istanbul ignore next */[]));
      this.executing = signal(false, ...(ngDevMode ? [{
        debugName: "executing"
      }] : /* istanbul ignore next */[]));
      this.success = signal(null, ...(ngDevMode ? [{
        debugName: "success"
      }] : /* istanbul ignore next */[]));
    }
    execute() {
      const userId = this.user().id;
      const conversionType = this.selectedConversion();
      if (!userId || !conversionType) {
        this.messages.createAndDisplay().setError('Es fehlen Angaben!');
        return;
      }
      this.executing.set(true);
      this.requestService.sendRequest(ManagerConvertUserRequest, {
        userId,
        conversionType
      }).subscribe({
        next: response => {
          this.success.set(response.success);
          if (!response.success) {
            this.messages.create().setError(response.error || 'Unbekannter Fehler');
          }
          this.crudManager.navigateTo('list');
          this.crudManager.reload();
          this.executing.set(false);
        },
        error: err => {
          this.success.set(false);
          console.log(err, this.messages);
          this.messages.add(err);
          this.executing.set(false);
        }
      });
    }
    closeDialog() {
      this.ref.close(null);
    }
    static {
      this.ɵfac = function UserConvertComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UserConvertComponent)(i0.ɵɵdirectiveInject(i1.AppRequestService), i0.ɵɵdirectiveInject(i2.CrudManagerService), i0.ɵɵdirectiveInject(i1.LocalMessageHandlerService), i0.ɵɵdirectiveInject(i3.DynamicDialogRef));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UserConvertComponent,
        selectors: [["ng-component"]],
        inputs: {
          user: [1, "user"]
        },
        features: [i0.ɵɵProvidersFeature([LocalMessageHandlerService])],
        decls: 3,
        vars: 3,
        consts: [[1, "inner-wrapper"], [3, "ngLet"], [1, "ui-simpletable"], ["placeholder", "Konvertieren zu...", 3, "ngModelChange", "options", "ngModel"], ["uiButton", "", "label", "Konvertierung ausf\u00FChren", 1, "ui-toolbar-group-right", 3, "click", "disabled"], ["type", "success"], ["uiButton", "", "label", "Dialog schlie\u00DFen", 3, "click"]],
        template: function UserConvertComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, UserConvertComponent_Conditional_0_Template, 18, 3, "div", 0);
            i0.ɵɵconditionalCreate(1, UserConvertComponent_Conditional_1_Template, 1, 1, null, 1);
            i0.ɵɵconditionalCreate(2, UserConvertComponent_Conditional_2_Template, 1, 0, "ui-spinner");
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.initialized() && !ctx.success() ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.initialized() ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.initialized() || ctx.executing() ? 2 : -1);
          }
        },
        dependencies: [FormsModule, i4.NgControlStatus, i4.NgModel, ReactiveFormsModule, i5.UiInputDropdownComponent, UiSpinnerComponent, UiToolbarComponent, UiButtonComponent, AppMessagesComponent, UiMessageComponent, NgLetDirective],
        styles: [".inner-wrapper[_ngcontent-%COMP%]{margin:20px}\n\n/*# sourceMappingURL=user-convert.component.ts-angular-inline--92.css.map*/"],
        changeDetection: 0
      });
    }
  }
  return UserConvertComponent;
})();